exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".box-informacao {\n  border: 1px \r solid whitesmoke;\n  background-color: whitesmoke;\n  border-radius: 5px;\n  color: black;\n  box-shadow: 0 3px 1px -2px rgba(0, 0, 0, 0.2), 0 2px 2px 0 rgba(0, 0, 0, 0.14), 0 1px 5px 0 rgba(0, 0, 0, 0.12); }\n\n@media (max-width: 800px) {\n  .box-align-apresentacao {\n    margin-bottom: 15px; } }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// C:/Users/anderson.oshiro/Projetos/Azure/Ipcorp.PortalCobranca/Web/Ipcorp.PortalCobranca.Web/src/app/components/apresentacao/apresentacao.component.scss
// module id = ../../../../../src/app/components/apresentacao/apresentacao.component.scss
// module chunks = main